import { namespace, resource } from "./localization";

export * from "./model";
export const locale = { namespace, resource };
